import { Component, OnInit, forwardRef } from '@angular/core';
import { AbstractNestedFormComponent } from '../../../shared/components/abstract-nested-form/abstract-nested-form.component';
import { FormGroup, FormControl, NG_VALUE_ACCESSOR, NG_VALIDATORS, Validators } from '@angular/forms';

@Component({
  selector: 'app-user-info-form',
  templateUrl: './user-info-form.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UserInfoFormComponent),
      multi: true
    },
      {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => UserInfoFormComponent),
      multi: true
    }
  ]
})
export class UserInfoFormComponent extends AbstractNestedFormComponent implements OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
    this.nestedForm = new FormGroup({
      firstName: new FormControl(null),
      lastName: new FormControl(null),
      birthDate: new FormControl(null),
      address: new FormControl(null),
      contact: new FormControl(null),
      fiscalCode: new FormControl(null),
      medId: new FormControl(null),
      privacyAgreement: new FormControl(null)
    });
  }

}
